// extracted by mini-css-extract-plugin
export default {"checkIcon":"CheckIcon_checkIcon__uPRef"};